var ReadingLevelFormat = {
	getMaxLexileValue(format) {
		var keys = _.keys(ReadingLevelFormat.LEXILE_TO_FORMATS[format]).filter(function(k){return parseInt(k)})
		return parseInt(keys[keys.length - 1])
	},
	getMinLexileValue(format) {
		var keys = _.keys(ReadingLevelFormat.LEXILE_TO_FORMATS[format]).filter(function(k){return parseInt(k)})
		return parseInt(keys[0])
	},
	getScoreForFormat(lexile_score, format) {
		if (lexile_score == null) {
			var scoreNormal = this.getMinLexileValue(format)
			return ReadingLevelFormat.LEXILE_TO_FORMATS[format][scoreNormal.toString()];
		}
		if (format == "Lexile Level") {
			return lexile_score.toString() + "L";
		} else {
			if (lexile_score.toString() in ReadingLevelFormat.LEXILE_TO_FORMATS[format]) {
				return ReadingLevelFormat.LEXILE_TO_FORMATS[format][lexile_score.toString()];
			}
			var maxLexileValue = this.getMaxLexileValue(format);
			if (lexile_score < maxLexileValue) {
				var scoreNormal = Math.round(lexile_score / ReadingLevelFormat.POINTS_PER_STEP) * ReadingLevelFormat.POINTS_PER_STEP;
			} else {
				var scoreNormal = maxLexileValue;
			}
			return ReadingLevelFormat.LEXILE_TO_FORMATS[format][scoreNormal.toString()];
		}
	},

	getLexileScoreForFormat(lexile_score, format) {
		if (lexile_score == null) {
			var scoreNormal = this.getMinLexileValue(format)
			return ReadingLevelFormat.LEXILE_TO_FORMATS[format][scoreNormal.toString()];
		}
		if (format == "Lexile Level") {
			return (Math.round(parseInt(lexile_score) / 5) * 5).toString();
		} else {
			if (lexile_score.toString() in ReadingLevelFormat.LEXILE_TO_FORMATS[format]) {
				return lexile_score.toString();
			}
			var maxLexileValue = this.getMaxLexileValue(format);
			if (lexile_score < maxLexileValue) {
				var scoreNormal = Math.round(lexile_score / ReadingLevelFormat.POINTS_PER_STEP) * ReadingLevelFormat.POINTS_PER_STEP;
			} else {
				var scoreNormal = maxLexileValue;
			}
			return scoreNormal.toString()
		}
	},

	lexileForGrade(gradelevel) {
		if (gradelevel < 1) {
			gradelevel = 1;
		} else if (gradelevel > 12) {
			gradelevel = 12
		}

		return ReadingLevelFormat.GRADE_LEVEL_TO_LEXILE[gradelevel];
	},

	getShortName(format) {
		return ReadingLevelFormat.FORMAT_TO_SHORT_NAME[format] || format;
	},

	getOriginName(origin) {
		return ReadingLevelFormat.ORIGINS[origin];
	},

	MAX_LEXILE: 2200,
	POINTS_PER_STEP: 50,

	LEXILE_TO_FORMATS: {
		"Lexile Level": { "BR":"BR","0":"0","50":"50","100":"100","150":"150","200":"200","250":"250","300":"300","350":"350","400":"400","450":"450","500":"500","550":"550","600":"600","650":"650","700":"700","750":"750","800":"800","850":"850","900":"900","950":"950","1000":"1000","1050":"1050","1100":"1100","1150":"1150","1200":"1200","1220":"1220" },
		"Grade": { "BR":"Pre-K","0":"K","25":"K","50":"1.1","75":"1.2","100":"1.2","125":"1.3","150":"1.3","175":"1.4","200":"1.5","225":"1.6","250":"1.6","275":"1.7","300":"1.8","325":"1.9","350":"2","375":"2.1","400":"2.1","425":"2.3","450":"2.5","475":"2.6","500":"2.7","525":"2.9","550":"3","575":"3.2","600":"3.3","625":"3.5","650":"3.7","675":"3.9","700":"4.1","725":"4.3","750":"4.5","775":"4.7","800":"5","825":"5.2","850":"5.5","875":"5.8","900":"6","925":"6.4","950":"6.7","975":"7","1000":"7.4","1025":"7.8","1050":"8.2","1075":"8.6","1100":"9","1125":"9.5","1150":"10","1175":"10.5","1200":"11","1225":"11.6","1250":"12.2","1275":"12.8","1300":"13.5" },
		"Ages": { "BR":"N/A","0":"4 - 6","50":"4 - 7","100":"6 - 7","150":"6 - 7","200":"6 - 7","250":"6 - 8","300":"7 - 8","350":"7 - 8","400":"7 - 8","450":"7 - 8","500":"7 - 9","550":"8 - 9","600":"8 - 9","650":"8 - 9","700":"8 - 11","750":"9 - 11","800":"9 - 11","850":"9 - 11","900":"10 - 12","950":"10 - 12","1000":"12 - 13","1050":"13 - 15"},
		"Reading Recovery": { "BR":"N/A","0":"A - B - 1","50":"2 - 4","100":"5 - 6","150":"7 - 8","200":"10 - 11","250":"11 - 12","300":"13 - 14","350":"15 - 16","400":"17 - 18","450":"19 - 20","500":"20","550":"22","600":"22","650":"22","700":"24","750":"26","800":"28","850":"28","900":"30","950":"30","1000":"32","1050":"34"},
		"DRA": { "BR":"N/A","0":"A - 1","25":"A-2","50":"2","75":"4","100":"4","125":"6","150":"8","175":"8","200":"10","225":"12","250":"14","275":"14","300":"14","325":"16","350":"16","375":"16","400":"18","425":"20","450":"20","475":"20","500":"24","525":"28","550":"28","575":"28","600":"30","625":"34","650":"36","675":"38","700":"38","725":"38","750":"40","775":"42","800":"50","900":"60","1000":"70","1050":"80"},
		"Rigby Literacy Levels": { "BR":"N/A","0":"1 - 2","50":"3 - 6","100":"7","150":"8 - 9","200":"10 - 11","250":"12","300":"12","350":"13","400":"14 - 16","450":"17","500":"18","550":"18","600":"19","650":"20"},
		"Rigby PM": { "BR":"N/A","0":"Starters 1","50":"2 - 6","100":"7-8 yellow","150":"9-10 blue","200":"13-14 green","250":"17 turquoise","300":"18 turquoise","350":"19-20 purple","400":"21 gold","450":"22 gold","500":"23 silver","550":"23 silver","600":"24 silver","650":"25 emerald","700":"26 emerald","750":"27 ruby","800":"29 sapphire","850":"30 sapphire" },
		"Reading A-Z Level": { "BR":"N/A","0":"aa - A","50":"B - D","100":"E","150":"F - G","200":"G - H","250":"I - J","300":"K","350":"L","400":"M - N","450":"O - P","500":"Q","550":"R","600":"S","650":"T","700":"U - V","750":"W","800":"X - Y","850":"Z"},
		"Fountas & Pinnell": { "BR":"N/A","0":"A","25":"A-B","50":"C","75":"C","100":"D","125":"E","150":"E","175":"F","200":"F","225":"F","250":"G","275":"G","300":"H","325":"I","350":"I","375":"I","400":"J","425":"J","450":"K","475":"K","500":"L","525":"L","550":"M","575":"M","600":"N","625":"O","650":"O","675":"P","700":"Q","725":"Q","750":"R","775":"S","800":"T","825":"U","850":"U","875":"V","900":"W","925":"X","950":"Y","975":"Y","1000":"Z","1025":"Z","1050":"Z","1075":"Z","1100":"Z","1125":"Z","1150":"Z","1175":"Z","1200":"Z","1225":"Z","1250":"Z","1275":"Z","1300":"Z"}
	},

	ORIGINS: {
		"TR": "Latest Diagnostic",
		"manual": "Manually Entered",
		"grade-level": "Grade Level Default"
	},

	FORMAT_TO_SHORT_NAME: {
		"Lexile Level": "Lexile",
		"Grade": "Grade",
		"Ages": "Ages",
		"Reading Recovery": "RR",
		"DRA": "DRA",
		"Rigby Literacy Levels": "Rigby Lit",
		"Rigby PM": "Rigby PM",
		"Reading A-Z Level": "RAZ",
		"Fountas & Pinnell": "F&P",
	},

	GRADE_LEVEL_TO_LEXILE: {
		1: 150,
		2: 350,
		3: 575,
		4: 800,
		5: 925,
		6: 1000,
		7: 1075,
		8: 1150,
		9: 1200,
		10: 1250,
		11: 1275,
		12: 1275
	}

};

module.exports = ReadingLevelFormat;



// WEBPACK FOOTER //
// ./modules/lib/academic/ReadingLevelFormat.js